import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const NewBadgeIcon = ({ className }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#FB8F44" />
    <path d="M10.97 11.49H9.57L6.4 6.7V11.49H5V4.5H6.4L9.57 9.3V4.5H10.97V11.49Z" fill="white" />
  </svg>
);
